import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

import { take, map } from 'rxjs';

import { AuthSessionService } from '@core/services/auth-session.service';

export const privilegedAccessGuard: CanMatchFn = () => {
  const router = inject(Router);
  const auth = inject(AuthSessionService);

  return auth.isPrivilegedAccess$.pipe(
    take(1),
    map((isPrivilegedAccess) => {
      if (isPrivilegedAccess) {
        return true;
      }

      return router.createUrlTree(['/inicio']);
    })
  );
};
